<template>
  <nuttrema-layout-three-vertical>

    <participant-standard-header
       slot="top"
      :meta="meta"
      :showOnMobileAndTablet="showOnMobileAndTablet">
    </participant-standard-header>

    <template slot="middle">

      <nuttrema-loader v-if="InvitationAccept.fetching || InvitationPreAccept.fetching"></nuttrema-loader>

      <template v-else-if="_isEmpty(token)">
        <nuttrema-empty-result icon="far fa-qrcode" class="with-logo">
          <template slot="text">
            <h1>{{ $t('label.missing_or_invalid_token') }}</h1>
            <h4>{{ $t('label.missing_token_help') }}</h4>
          </template>
        </nuttrema-empty-result>
      </template>

      <template v-else-if=" _get(InvitationPreAccept, 'error.constraint')">
        <nuttrema-empty-result icon="fal fa-exclamation-triangle" class="with-logo">
          <template slot="text">
            <h1>{{ _get(InvitationPreAccept, 'error.error') }}</h1>
            <h4>{{ _get(InvitationPreAccept, 'error.message') }}</h4>
          </template>
        </nuttrema-empty-result>
      </template>

      <form-join-instance
         v-else
         class="is-center-vertical"
        :edit="true"
        :token="token"
        :labelPosition="showOnMobileAndTablet ? 'top' : 'right'"
        :InvitationAccept="InvitationAccept"
        :InvitationPreAccept="InvitationPreAccept"
        @submit="onFormSubmit">
      </form-join-instance>

    </template>
    <!-- end ~ slot middle -->

  </nuttrema-layout-three-vertical>
</template>

<script>
import { PERSON } from 'constants/types';

import ParticipantStandardHeader from 'components/pages/participant/shared/participant-standard-header';
import NuttremaLayoutThreeVertical from 'components/ui/layout/nuttrema-layout-three-vertical';

import ResponsiveMonitor from 'components/mixins/responsive-monitor';
import PageJoinInstance from 'components/pages/shared/join-instance/page-join-instance';

export default {
  name: 'page-join-instance',
  mixins: [
    PageJoinInstance,
    ResponsiveMonitor,
  ],
  components: {
    ParticipantStandardHeader,
    NuttremaLayoutThreeVertical,
  },
  data() {
    return {
      type: PERSON.PARTICIPANT,
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/components/pages/participant/public/join-instance/page-join-instance.vue